import { Redirect } from 'react-router-dom';
import LoaderPage from '../Components/Common/Loader';
import RecordInteraction from '../Components/RecordInteraction/RecordInteraction';
import ViewResults from '../Components/ViewResults/ViewResults';
import RedirectPageLogic from '../Components/RedirectPage/RedirectPage.logic';
const PublicInteractiveRoleplay = () => {
  const { token, isLoading, showResults } = RedirectPageLogic();
  if (!token) return <Redirect to="/" />;
  if (isLoading) return <LoaderPage />;
  return showResults ? <ViewResults /> : <RecordInteraction />;
};

export default PublicInteractiveRoleplay;
